module.exports = __webpack_public_path__ + "../static/img/base_cisco_xe.b0a0300d.png";